// Where a Send goes, now that the task has one message box and one button.
//
// The scheduling panel used to have its own box and its own Send, which went to
// /ai-scheduling/approve-draft and recorded the offered times against the task.
// The reply box's Send went to /triage/tasks/:id/respond and recorded nothing
// about scheduling. Merging the boxes means one press has to know which of
// those it is — and /respond now carries times itself, so the answer is almost
// always /respond.
//
// The one exception is the AI-confirmation branch: approve-draft is the only
// path that CREATES an appointment, so a task waiting on a confirmation still
// goes there. Everything else is a message.

export type SendPath = 'respond' | 'approve-draft';

export interface SendContext {
  pendingType?: string | null;
  status?: string | null;
  slots: unknown[];
}

export interface SendPlan {
  path: SendPath;
  /** The times to record against the task. `undefined` means leave the
   *  scheduling state alone; an empty array means "resolve the pending draft
   *  with no times offered". */
  slots: unknown[] | undefined;
}

export function planSend({ pendingType, status, slots }: SendContext): SendPlan {
  if (pendingType === 'confirmation') {
    return { path: 'approve-draft', slots: undefined };
  }
  // Decided with the practice: sending anything on a task that is waiting for
  // approval resolves it. Staff answered the patient; the AI's suggestion is
  // moot. Sending an empty list is what tells the backend to clear the pending
  // state rather than leave "Needs Approval" lit on an answered task.
  const offering = slots.length > 0 || status === 'pending_approval';
  return { path: 'respond', slots: offering ? slots : undefined };
}
